import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { confirmAlert } from "react-confirm-alert";
import ResetIcon from "../Asset/ResetIcon.svg";
import { getMMPLUsersDetails } from "../Actions/UserManagementAPI";
import {
  putClientUserDetails,
  getClientManagementList,
  getClientUserList,
  getSpecialClientUsersManagementList,
  putSpecialAccesDetails,
} from "../Actions/ClientManagementAPI";

let user = JSON.parse(localStorage.getItem("currentUser"));
class UsersCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;

    return (
      <div className="" style={{ paddingTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <Paginator
            className="mb-3"
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                No Item to Display
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, DeleteUser, resetPasswordclick } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
          return (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div className="p-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-md-10 col-sm-9 col-9 col-m-auto"}>
                      <div className="row px-4">
                        <div className={showSidePane ? "col-sm-4" : "col-sm-4"}>
                          <span>
                            <strong>Name : </strong>
                            <span className="italicFont ">{item.name}</span>
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-4" : "col-sm-4"}>
                          <span>
                            <strong>Email : </strong>
                            <span className="italicFont ">
                              {item.email ?? ""}
                            </span>
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-4" : "col-sm-4"}>
                          <span>
                            <strong>Phone Number : </strong>
                            <span className="italicFont ">
                              {item.phone ?? ""}
                            </span>
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-12" : "col-sm-12"}>
                          <span>
                            <strong>Company : </strong>
                            <span className="italicFont ">
                              {item.clients.map(i=>i.clientName).join(", ") ?? ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={"col-sm-3 col-md-2 col-m-auto col-3"}>
                      <div
                        className={`${showSidePane ? "text-center" : "text-center"} flex-wrap flex-md-nowrap`}
                        style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "18px" }}
                      >
                        <img
                          src={ResetIcon}
                          width={29}
                          height={29}
                          onClick={() => resetPasswordclick(item)}
                          style={{ cursor: "pointer" }}
                        />
                        <i
                          className="fa fa-edit fa-2x fa-lg click"
                          aria-hidden="true"
                          onClick={() => this.ShowSidePanel(item)}
                          style={{ color: " #1E3A8A" }}
                        ></i>
                        <i
                          className="fa fa-trash-o fa-2x click"
                          aria-hidden="true"
                          style={{ color: " #1E3A8A" }}
                          onClick={() => this.DeletePopup(item)}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : null;
  };

  ShowSidePanel = (item) => {
    // this.props.dispatch(getMMPLUsersDetails(item.userId));
    this.props.dispatch({ type: "specialAccessDetail", data: item });
    //  this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(
      `/Home/Management/SpecialAccessEdit/${item.clientUserId ?? 0}`
    );
  };

  DeletePopup(item) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.DeleteUser(item);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  DeleteUser = async (item) => {
    const { dispatch } = this.props;
    console.log("delete");
    let userData = [
      {
        clientUserId: item.clientUserId,
        role: "SpecialAccess",
        name: item.name,
        email: item.email,
        address: "",
        phone: item.phone,
        isDeleted: true,
        modifiedBy: user.name,
        clients:item.clients
      },
    ];
    dispatch(putSpecialAccesDetails(userData));
    // await dispatch(getSpecialClientUsersManagementList());
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UsersCard)
);
